module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-token u-relative u-bg--black"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "p-token__first-container u-relative"
  }, [_c('div', {
    staticClass: "p-token__first-container__border u-absolute u-pos-tr u-zindex--1 u-fit-h u-bg--brand-primary u-overflow-h"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-token__first-container__header u-relative u-zindex--2 u-marg-x-auto u-w10of12 u-viewport-fit-h"
  }, [_c('div', {
    staticClass: "p-token__first-container__header__logotype u-marg-x-auto"
  }, [_c('div', {
    staticClass: "p-token__first-container__header__logotype__sprite-container js-logotype-sprite-container o-box--1by1 u-relative u-overflow-h"
  }, [_c('img', {
    staticClass: "p-token__first-container__header__logotype__sprite js-logotype-sprite u-absolute u-pos-tl u-opacity--0",
    class: [_vm.sprite.state === 'created' ? 'is-created' : ''],
    attrs: {
      "src": "/static/images/page-token-logotype-sprite.png",
      "alt": "",
      "title": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-token__first-container__header__title--top u-fit-w"
  }), _vm._v(" "), _c('h2', {
    staticClass: "p-token__first-container__header__title js-titles-disappear t-fweight--light u-color--white u-align-center",
    attrs: {
      "data-opacity-offset": "0"
    }
  }, [_vm._v("Meet PRAX")]), _vm._v(" "), _c('div', {
    staticClass: "p-token__first-container__header__title-links-container--top u-fit-w"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-token__first-container__header__title-links-container js-titles-disappear u-align-center",
    attrs: {
      "data-opacity-offset": "0.5"
    }
  }, [_c('span', {
    staticClass: "p-token__first-container__header__title-links u-uppercase u-color--white t-fsize--xs t-ffamily--simplon t-fweight--bold u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm.scrollTo(_vm.visualizationPosition)
      }
    }
  }, [_vm._v("Supply")]), _vm._v(" "), _c('span', {
    staticClass: "u-marg-x-xs u-inline-block u-uppercase u-color--white t-fsize--xs t-ffamily--simplon t-fweight--bold u-opacity--50"
  }, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "p-token__first-container__header__title-links u-uppercase u-color--white t-fsize--xs t-ffamily--simplon t-fweight--bold u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm.scrollTo(_vm.economicsPosition)
      }
    }
  }, [_vm._v("Tokenomics")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-token__first-container___table o-content u-w8of12 u-marg-x-auto"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "p-token__first-container___table-row u-color--white u-lheight--150p u-flex u-flex-jc--start u-flex-fd--column@sm"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "o-content is-white u-marg-t-sm@sm u-w3of6 u-fit-w@sm u-color--white u-lheight--150p"
  }, [_vm._m(4), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": _vm.$root.content.global.whitepaper.url,
      "target": "_blank",
      "rel": "noreferrer noopener"
    }
  }, [_vm._v("Find out more on the PRAX Balancing System in our whitepaper.")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-token__second-container u-relative u-overflow-h"
  }, [_c('div', {
    staticClass: "p-token__second-container__border u-absolute u-pos-tr u-zindex--1 u-fit-h u-bg--brand-primary"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-token__second-container__wrapper u-relative u-marg-x-auto u-zindex--2 u-w10of12"
  }, [_c('div', {
    staticClass: "p-token__second-container__row js-s-container-row-1 u-flex u-flex-jc--space-between u-flex-fd--column@sm"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "p-token__second-container__right-item u-relative u-marg-t-xl@sm u-w1of2"
  }, [_c('app-token-prac-earned', {
    staticClass: "u-absolute",
    attrs: {
      "label": "James's wallet",
      "prax": _vm.user1Prax
    }
  }), _vm._v(" "), _c('div', {
    ref: "scene1",
    staticClass: "p-token-scene u-relative",
    class: [_vm.user1Active ? 'has-step-earn' : '']
  }, [_vm._m(6)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-token__second-container__row js-s-container-row-2 u-flex u-flex-jc--space-between u-flex-fd--column@sm"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "p-token__second-container__right-item u-relative u-marg-t-xl@sm u-w1of2"
  }, [_c('app-token-prac-earned', {
    staticClass: "u-absolute",
    attrs: {
      "label": "Sarah's wallet",
      "prax": _vm.user2Prax
    }
  }), _vm._v(" "), _c('div', {
    ref: "scene2",
    staticClass: "p-token-scene u-relative",
    class: [_vm.user2Active ? 'has-step-use' : '']
  }, [_vm._m(8)])], 1)])])]), _vm._v(" "), _c('app-newsletter'), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-token__background u-absolute u-pos-tl u-viewport-fit js-background"
  }, [_c('div', {
    staticClass: "p-token__background-gradient u-absolute u-pos-bl u-fit-w"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-token__scroll-container u-absolute u-pos-tl u-zindex--2 u-viewport-fit"
  }, [_c('div', {
    staticClass: "p-token__scroll-container__wrapper js-titles-disappear u-absolute u-flex u-flex-fd--column u-flex-jc--center u-flex-ai--center u-fit-w",
    attrs: {
      "data-opacity-offset": "2"
    }
  }, [_c('div', {
    staticClass: "p-token__scroll-container__wrapper__line u-bg--white u-opacity--20"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-token__scroll-container__wrapper__icon-container u-relative"
  }, [_c('div', {
    staticClass: "p-token__scroll-container__wrapper__icon-container__border u-relative u-flex u-flex-ai--start u-fit"
  }, [_c('div', {
    staticClass: "p-token__scroll-container__wrapper__icon-container__dot u-bg--white"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-token__first-container___table-row u-color--white u-lheight--150p u-flex u-flex-jc--start u-flex-fd--column@sm"
  }, [_c('div', {
    staticClass: "u-w2of6 u-fit-w@sm"
  }, [_c('h3', {
    staticClass: "p-token__first-container___table-title u-relative u-inline-block t-fweight--medium u-color--white"
  }, [_c('span', {
    staticClass: "p-token__first-container___table-number u-absolute u-relative@sm u-pos-tl u-inline-block t-ffamily--simplon u-opacity--50"
  }, [_vm._v("01")]), _vm._v(" "), _c('span', {
    staticClass: "u-inline-block u-block@sm"
  }, [_vm._v("Supply")])])]), _vm._v(" "), _c('div', {
    staticClass: "o-content u-marg-t-sm@sm u-w3of6 u-fit-w@sm u-color--white u-lheight--150p"
  }, [_c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("PRAX will be hard-capped at 100M tokens with 4m committed through our pre-sale, 15m sold on token generation day, and 21m locked for long-term daily sale distributions with halvings every (4) four years.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-w2of6 u-fit-w@sm"
  }, [_c('h3', {
    staticClass: "p-token__first-container___table-title u-relative u-inline-block t-fweight--medium u-color--white"
  }, [_c('span', {
    staticClass: "p-token__first-container___table-number u-absolute u-relative@sm u-pos-tl u-inline-block t-ffamily--simplon u-opacity--50"
  }, [_vm._v("02")]), _vm._v(" "), _c('span', {
    staticClass: "u-inline-block u-block@sm"
  }, [_vm._v("Tokenomics")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("Sustainability is key to the success of a token. We have invented a specialized balancing system that ensures we continue to reward participants for their efforts, but also prevent platform costs from spiraling out of control.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-token__second-container__left-item u-w1of2 u-fit-w@sm"
  }, [_c('div', {
    staticClass: "p-token__second-container__left-item__wrapper u-relative u-marg-r-xxl u-fit-w@sm u-marg-x-auto@sm"
  }, [_c('div', {
    staticClass: "p-token__second-container__left-item__subtitle u-absolute t-fweight--medium u-uppercase u-color--brand-primary"
  }, [_vm._v("\n                            Earn\n\n                            "), _c('div', {
    staticClass: "p-token__second-container__left-item__subtitle__line u-absolute u-pos-bl u-bg--brand-primary"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token__second-container__left-item__content u-marg-t-sm@sm u-fit-w@sm"
  }, [_c('div', {
    staticClass: "p-token__second-container__left-item__content__title t-fweight--light u-color--white u-lheight--150p"
  }, [_vm._v("\n                                Contribute work, get rewarded.\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "p-token__second-container__left-item__content__description o-content is-white u-color--white u-lheight--150p"
  }, [_c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("When work is submitted through GATEWAY or KEY SDK, it goes through a centralized validation process to prevent bad actors, then we calculate the reward based on the type of data submitted, and the amount of PRAX held within the reserve. The final amount is split three ways, 70% to the worker, 20% to the third-party developer (if applicable), and 10% into Practical's daily sale.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-token-scene__pivot js-token-scene-pivot"
  }, [_c('div', {
    staticClass: "p-token-scene__label"
  }, [_vm._v("Mapping...")]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__floor"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube has-index-0"
  }, [_c('div', {
    staticClass: "p-token-scene__cube-face has-index-0 has-delay-0"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-1 has-delay-0"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-2 has-delay-0"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-3 has-delay-0"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-4"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube has-index-1"
  }, [_c('div', {
    staticClass: "p-token-scene__cube-face has-index-0 has-delay-1"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-1 has-delay-1"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-2 has-delay-1"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-3 has-delay-1"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-5"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube has-index-2"
  }, [_c('div', {
    staticClass: "p-token-scene__cube-face has-index-0 has-delay-2"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-1 has-delay-2"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-2 has-delay-2"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-3 has-delay-2"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube has-index-3"
  }, [_c('div', {
    staticClass: "p-token-scene__cube-face has-index-0 has-delay-3"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-7"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-1 has-delay-3"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-7"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-2 has-delay-3"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-7"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-3 has-delay-3"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-7"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube has-index-4"
  }, [_c('div', {
    staticClass: "p-token-scene__cube-face has-index-0 has-delay-4"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-1 has-delay-4"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-2 has-delay-4"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-3 has-delay-4"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-8"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__token has-index-0"
  }, [_c('div', {
    staticClass: "p-token-scene__token-image has-delay-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__token has-index-1"
  }, [_c('div', {
    staticClass: "p-token-scene__token-image has-delay-9"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__token has-index-2"
  }, [_c('div', {
    staticClass: "p-token-scene__token-image has-delay-10"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__token has-index-5"
  }, [_c('div', {
    staticClass: "p-token-scene__token-image has-delay-13"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__token has-index-6"
  }, [_c('div', {
    staticClass: "p-token-scene__token-image has-delay-14"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-token__second-container__left-item u-w1of2 u-fit-w@sm"
  }, [_c('div', {
    staticClass: "p-token__second-container__left-item__wrapper u-relative u-marg-r-xxl u-fit-w@sm u-marg-x-auto@sm"
  }, [_c('div', {
    staticClass: "p-token__second-container__left-item__subtitle u-absolute t-fweight--medium u-uppercase u-color--brand-primary"
  }, [_vm._v("\n                            Use\n                            "), _c('div', {
    staticClass: "p-token__second-container__left-item__subtitle__line u-absolute u-pos-bl u-bg--brand-primary"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token__second-container__left-item__content u-marg-t-sm@sm u-fit-w@sm"
  }, [_c('div', {
    staticClass: "p-token__second-container__left-item__content__title t-fweight--light u-color--white u-lheight--150p"
  }, [_vm._v("\n                                Stake for time and persistence.\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "p-token__second-container__left-item__content__description o-content is-white u-color--white u-lheight--150p"
  }, [_c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("Stakes of PRAX will decay at time and usage based intervals. The decay process will return 100% of PRAX used back into the reward system to fuel further contributions to the network. At launch, it can be used for spatial loading, advanced spatial placement, and real-time holographic customizations.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-token-scene__pivot js-token-scene-pivot"
  }, [_c('div', {
    staticClass: "p-token-scene__label"
  }, [_vm._v("Downloading...")]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__floor"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube has-index-0"
  }, [_c('div', {
    staticClass: "p-token-scene__cube-face has-index-0 has-delay-0"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-1 has-delay-0"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-2 has-delay-0"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-3 has-delay-0"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-4"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube has-index-1"
  }, [_c('div', {
    staticClass: "p-token-scene__cube-face has-index-0 has-delay-1"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-1 has-delay-1"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-2 has-delay-1"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-3 has-delay-1"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-5"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube has-index-2"
  }, [_c('div', {
    staticClass: "p-token-scene__cube-face has-index-0 has-delay-2"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-1 has-delay-2"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-2 has-delay-2"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-3 has-delay-2"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube has-index-3"
  }, [_c('div', {
    staticClass: "p-token-scene__cube-face has-index-0 has-delay-3"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-7"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-1 has-delay-3"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-7"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-2 has-delay-3"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-7"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-3 has-delay-3"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-7"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube has-index-4"
  }, [_c('div', {
    staticClass: "p-token-scene__cube-face has-index-0 has-delay-4"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-1 has-delay-4"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-2 has-delay-4"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__cube-face has-index-3 has-delay-4"
  }, [_c('span', {
    staticClass: "p-token-scene__cube-face-inner has-delay-8"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__token has-index-0"
  }, [_c('div', {
    staticClass: "p-token-scene__token-image has-delay-8"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__token has-index-1"
  }, [_c('div', {
    staticClass: "p-token-scene__token-image has-delay-9"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__token has-index-2"
  }, [_c('div', {
    staticClass: "p-token-scene__token-image has-delay-10"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__token has-index-5"
  }, [_c('div', {
    staticClass: "p-token-scene__token-image has-delay-13"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-token-scene__token has-index-6"
  }, [_c('div', {
    staticClass: "p-token-scene__token-image has-delay-14"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0447440"}!./src/scripts/components/page-token/template.html
// module id = 481
// module chunks = 0